<template>
  <div>
    <div>
      <div class="formPosition">
        <v-card style="margin: auto" width="1200">
          <v-overlay :value="progresso_overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>
          <v-card-title style="background-color: #006699; color: white"></v-card-title>

          <v-data-table :headers="headers" :items="multasPrazo" :search="searchInDb" sort-by="data_"
            class="elevation-3">
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-btn @click="openDialog()" style="background-color: #006699; color: white"
                  outlined>
                  <v-icon md color="white darken-2">add</v-icon> Registrar novo
                  prazo
                </v-btn>

                <v-divider class="mx-8" inset vertical></v-divider>
                <v-toolbar-title>Consultar prazos de multa</v-toolbar-title>
                <v-divider class="mx-8" inset vertical></v-divider>
                <!--  search  -->
                <div class="flex-grow-1"></div>
                <v-btn v-if="searchInDb" @click="initialize(searchInDb)" text icon color="green">
                  <v-icon>cached</v-icon>
                </v-btn>
                <v-text-field v-model="searchInDb" append-icon="search" label="Pesquisa" single-line
                  hide-details></v-text-field>
                <!-- end  search  -->
              </v-toolbar>
            </template>
            <template v-slot:item.index="{ item }">
              <span> {{ multasPrazo.indexOf(item) + 1 }}</span>
            </template>
            <template v-slot:item.fkMes="{ item }">
              <span>{{ utilitarios.getMonthDescription(item.fkMes) }}</span>
            </template>
            <template v-slot:item.cobrar="{ item }">
              <span>{{ item.cobrar === 1 ? "Sim" : "Não" }}</span>
            </template>
            <template v-slot:item.action="{ item }">
              <v-menu bottom origin="center center" transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn fab dark small color="#006699" v-bind="attrs" v-on="on">
                    <v-icon dark>menu</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="SetEditItem(item)"><v-icon color="#006699"
                      small>edit</v-icon>Editar</v-list-item>
                  <v-list-item @click="setEliminar(item)"><v-icon color="red"
                      small>delete</v-icon>Eliminar</v-list-item>
                </v-list>
              </v-menu>
            </template>
            <template v-slot:no-data>
              <!--   <v-btn color="primary" @click="initialize">Reset</v-btn>  -->
              Clica em + para adicionar novo estudante
            </template>
          </v-data-table>
        </v-card>

        <!-- ================================== ELIMINAR ========================================= -->

        <v-row justify="center">
          <v-dialog v-model="dialogoElimar" persistent max-width="490">
            <v-card>
              <v-overlay :value="overlayEliminar">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
              </v-overlay>
              <v-card-title class="headline">Desejas continuar com essa operação?</v-card-title>
              <v-card-text><b>Essa operação poderá afectar o sistema</b>, deseja continuar
                com a operação ?
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="black darken-1" text @click="dialogoElimar = false">Cancelar</v-btn>
                <v-btn color="green darken-1" text @click="EliminarPrazoMulta()">Continuar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>

        <!-- ============================== DIALOGO Para salvar uma turma ====================== -->

        <template>
          <v-row justify="center">
            <v-dialog v-model="dialog" persistent max-width="600px">
              <v-card>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-overlay :value="overlay">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                  </v-overlay>
                  <v-card-title style="background-color: #006699; color: white">
                    <span class="text-h5">Definir Prazo de Multa</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="4" sm="4" md="4">
                          <v-select outlined v-model="editedItem.month" :rules="ruleRequired" item-value="id"
                            item-text="descricao" :items="meses" chips label="Selecione o mês"
                            @change="cleanDates()"></v-select>
                        </v-col>
                        <v-col cols="4" sm="4" md="4">
                          <template>
                            <v-menu ref="menuMulta" v-model="menuMulta" :close-on-content-click="false"
                              transition="scale-transition" offset-y full-width min-width="290px">
                              <template v-slot:activator="{ on }">
                                <v-text-field v-model="dataMultaSelected" :rules="[(v) => !!v || 'Campo obrigatorio!']"
                                  label="Escolha uma data" :disabled="editedItem.month === null" prepend-icon="event"
                                  readonly v-on="on"></v-text-field>
                              </template>
                              <v-date-picker ref="picker" :max="maxYear" :min="minYear" v-model="editedItem.date1"
                                @change="
                                  setDateOnView(
                                    utilitarios.AdicionarDiasaUmaData(
                                      editedItem.date1
                                    )
                                  )
                                  "></v-date-picker>
                            </v-menu>
                          </template>
                        </v-col>

                        <v-col cols="4" sm="4" md="4">
                          <div class="tpaCombox">
                            <v-combobox v-model="premissaoCobrar" :rules="[(v) => !!v || 'Campo obrigatorio!']"
                              label="Cobrar" item-value="id" item-text="descricao" :items="estados" return-object
                              rounded>
                            </v-combobox>
                          </div>
                        </v-col>
                      </v-row>
                    </v-container>
                    <span style="color: red; font-weight: bold">Atenção :</span><span style="font-weight: bold">{{
                      this.editedItem.month === null
                        ? ""
                        : this.editedItem.month.descricao
                    }}
                      vai ser definido como o {{ this.multasPrazo.length + 1 }}º
                      mês de cobrança.</span><br />
                    <small>*Preencha correctamente os campos</small>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="black darken-1" text @click="close()">
                      fechar
                    </v-btn>
                    <v-btn color="green darken-1" text :disabled="!valid" @click="Guardar()">
                      Guardar
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
          </v-row>
        </template>
        <!-- ===================================================================================== -->

        <!-- ============================== DIALOGO EDITAR DATA MULTA ====================== -->

        <template>
          <v-row justify="center">
            <v-dialog v-model="dialogEditar" persistent max-width="600px">
              <v-card>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-overlay :value="overlay">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                  </v-overlay>
                  <v-card-title style="background-color: #006699; color: white">
                    <span class="text-h5">Definir Prazo de Multa</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="4" sm="4" md="4">
                          <v-text-field outlined label="Mês Selecionado" :readonly="true" v-model="editedItem.month">
                          </v-text-field>
                        </v-col>
                        <v-col cols="4" sm="4" md="4">
                          <template>
                            <v-menu ref="menuMulta" v-model="menuMulta" :close-on-content-click="false"
                              transition="scale-transition" offset-y full-width min-width="290px">
                              <template v-slot:activator="{ on }">
                                <v-text-field v-model="dataMultaSelected" :rules="[(v) => !!v || 'Campo obrigatorio!']"
                                  label="Escolha uma data" prepend-icon="event" readonly v-on="on"></v-text-field>
                              </template>
                              <v-date-picker ref="picker" :max="maxYear" :min="minYear" v-model="editedItem.date1"
                                ></v-date-picker>
                            </v-menu>
                          </template>
                        </v-col>
                        <v-col cols="4" sm="4" md="4">
                          <div class="tpaCombox">
                            <v-combobox v-model="premissaoCobrar" label="Cobrar" item-value="id" item-text="descricao"
                              :items="estados" return-object rounded>
                            </v-combobox>
                          </div>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="black darken-1" text @click="dialogEditar = false">
                      fechar
                    </v-btn>
                    <v-btn color="green darken-1" text :disabled="!valid" @click="Editar()">
                      Editar
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
          </v-row>
        </template>
        <!-- ===================================================================================== -->
      </div>
    </div>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import axios from "../../plugins/axios";
import utilitarios from "../../plugins/utilitarios";
const ls = require("local-storage");
export default {
  data: () => ({
    arrayferiados: [],
    estados: [
      { id: 1, descricao: "Sim" },
      { id: 0, descricao: "Não" },
    ],
    premissaoCobrar: null,
    headers: [
      { text: "#", value: "index" },
      {
        text: "Mês",
        align: "left",
        sortable: false,
        value: "fkMes",
      },
      { text: "Ordem de Cobrança", value: "ordemCobranca" },
      //  { text: 'Semestre', value: 'semestre' },
      { text: "Data", value: "p1" },
      { text: "Data criação", value: "data_" },
      { text: "Cobrar", value: "cobrar" },
      { text: "Autor", value: "autor" },
      { text: "Ação", value: "action" },
    ],
    dataMultaSelected: null,
    utilitarios: utilitarios,
    objecto: null,
    progresso_overlay: false,
    overlayEliminar: false,
    searchInDb: "",
    multasPrazo: [],
    dialogEditar: false,
    dialogoElimar: false,
    overlay: false,
    isLoading: false,
    dialog: false,
    overlay: false,
    valid: true,
    meses: [],
    maxYear: "",
    minYear: "",
    editedItem: {
      month: null,
      date1: "",
      autor: ls.get("nomeUsuario"),
      id: 0,
    },
    defaultItem: {
      month: null,
      date1: "",
      autor: ls.get("autor"),
      id: 0,
    },
    multaObject: null,
    ruleRequired: [(value) => !!value || "campo obrigatorio"],
  }),

  computed: {
    mesesAPagar() {
      return ls.get("meses");
    },
    isAdm() {
      return ls.get("role") === "ROLE_ADM" || ls.get('role') === "ROLE_RCI";
    },
  },

  created() {
    // this.getFeriados()
    this.meses = utilitarios.MonthsOfYear();
    this.initialize();
    this.SetMaxYear();
    this.SetMinYear();
  },

  methods: {
    async getFeriados() {
      try {
        this.arrayferiados = await axios
          .get("/feriadosAll")
          .then((res) => res.data);
        ls.set("feriados", this.arrayferiados);
      } catch (error) { }
    },

    SetEditItem(item) {
      this.dialogEditar = true;
      this.editedItem.month = utilitarios.getMonthDescription(item.fkMes);
      this.dataMultaSelected = item.p1;
      this.multaObject = item;
      this.premissaoCobrar = this.estados.filter((e) => e.id == item.cobrar)[0];
    },

    openDialog() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.resetValidation();
    },
    SetMaxYear() {
      this.maxYear = parseInt(ls.get("anolectivo")) + 1 + "-12-31";
    },
    SetMinYear() {
      this.minYear = ls.get("anolectivo") + "-01-01";
    },

    async setDateOnView(dateMulta) {
      this.editedItem.date1 = dateMulta.data;
      this.$refs.menuMulta.save(dateMulta.data);
      this.dataMultaSelected = new Date(dateMulta.data)
        .toISOString()
        .substr(0, 10);
    },

    resetValidation() {
      this.$refs.form.reset();
    },

    async initialize() {
      axios.get("/ListarMeses-Multa").then((res) => {
        ls.set("meses", res.data);
      });
      try {
        this.progresso_overlay = true;
        this.multasPrazo = await axios
          .get("prazoMultaFindAll")
          .then((res) => res.data);
        this.progresso_overlay = false;
      } catch (error) {
        this.progresso_overlay = false;
        Swal.fire(
          "Informação",
          "Ocorreu um erro ao tentar efectuar essa operação",
          "error"
        );
      }
    },

    setEliminar(item) {
      this.dialogoElimar = true;
      this.objecto = item;
    },

    async EliminarPrazoMulta() {
      try {
        this.overlayEliminar = true;
        let result = await axios
          .post("eliminarPrazoMulta", { data: this.objecto })
          .then((res) => res.data);
        if (result.affectedRows >= 1) {
          this.dialogoElimar = false;
          this.initialize();
          utilitarios.showAlertMessage(
            "success",
            "Registro eliminado com sucesso."
          );
        } else {
          utilitarios.showAlertMessage(
            "error",
            "Ocorreu um erro ao tentar efectuar a operação."
          );
        }
        this.overlayEliminar = false;
      } catch (error) {
        this.overlayEliminar = false;
      }
    },

    async Editar() {
      if (this.$refs.form.validate()) {
        try {
          this.overlay = true;
          let results = await axios
            .post("definirPrazoMultaUpdate", {
              data: this.dataMultaSelected,
              item: this.multaObject,
              cobrar: this.premissaoCobrar.id
            })
            .then((res) => res.data);
          if (results.affectedRows >= 1) {
            Swal.fire(
              "Informação",
              "Actualização feita com sucesso",
              "success"
            );
            this.initialize();
            this.dialogEditar = false;
          } else {
            Swal.fire(
              "Informação",
              "Ocorreu um erro ao tentar efectuar a operação",
              "error"
            );
          }
          this.overlay = false;
        } catch (error) {
          this.overlay = false;
          Swal.fire(
            "Informação",
            "Ocorreu um erro ao tentar efectuar a operação",
            "error"
          );
        }
      }
    },

    async Guardar() {
      if (this.$refs.form.validate()) {
        // verifique se já foi definido o prazo para este mês e anolectivo
        let mesJaDefinido = this.multasPrazo.filter(
          (f) =>
            f.fkMes === parseInt(this.editedItem.month) &&
            f.anolectivo === ls.get("anolectivo")
        );
        if (mesJaDefinido.length) {
          utilitarios.showAlertMessage(
            "warning",
            "Prazo já definido para este mês."
          );
        } else {
          try {
            this.overlay = true;
            let results = await axios
              .post("definirPrazoMultaInsertOrUpdate", {
                item: this.editedItem,
                ordem: this.multasPrazo.length + 1,
                cobrar: this.premissaoCobrar.id
              })
              .then((res) => res.data);
            if (results.affectedRows >= 1) {
              utilitarios.showAlertMessage(
                "success",
                "Definição de multa feita com sucesso."
              );
              this.initialize();
              this.close();
            } else {
              utilitarios.showAlertMessage(
                "error",
                "Ocorreu um erro ao tentar efectuar a operação"
              );
              this.close();
            }
          } catch (error) {
            if (error.toString().includes("409")) {
              utilitarios.showAlertMessage(
                "warning",
                "Prazo de Multa já definido"
              );
            } else {
              utilitarios.showAlertMessage(
                "error",
                "Erro ao tentar efectuar a operação"
              );
            }
          } finally {
            this.overlay = false;
          }
        }
      }
    },
  },
};
</script>

<style scoped>
.bg {
  color: green;
  background: red;
}

.tpaCombox {
  height: 50px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 0 3px;
}
</style>
